<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <div
      class="bg-white poppins d-flex flex-column"
      style="height: 520px;"
    >
      <div class="flex-grow-1 overflow-y-auto px-5 pt-7">
        <SKUSDataTable :forView="forView" />
      </div>

      <div class="d-flex justify-center py-5 border-top">
        <button
          class="btn btn-light px-5 py-3 ls1"
          @click="dialog = false"
        >
          Close
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import SKUSDataTable from "@/own/components/orderManagement/subscriptionManagement/SKUSDataTable";
export default {
  name: "ViewSKUSModal",
  components: { SKUSDataTable },
  props: {
    forView: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    toggleDialog() {
      this.dialog = !this.dialog;
    },
  },
};
</script>
